// istanbul ignore file
import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import Picture from '@cotyorg/ccx-atoms/Picture/components/Picture';

// Added inline for now to prevent further updates to brand sites
// TODO: [1] standardise
// Min width and min height added to ensure intersection observer fires
const lazyLoadStyles = {
  minWidth: '1px',
  minHeight: '1px',
};

// TODO: [1] fix root margin in iframe bug (currently it does not work correctly)
const LazyLoad = ({
  rootMargin = '1500px',
  ...props
}) => {
  const [ref, inView] = useInView({
    rootMargin,
    triggerOnce: true,
    // TODO: [1] investigate passing in root element,
  });

  if (!props.src && !props.srcset) {
    return null;
  }

  return (
    <div ref={ref} style={lazyLoadStyles}>
      <Picture
        {...props}
        isWithinViewport={inView}
      />
    </div>
  );
};

LazyLoad.propTypes = {
  rootMargin: PropTypes.string,
  src: PropTypes.string,
  srcset: PropTypes.arrayOf(PropTypes.object),
};

export default React.memo(LazyLoad);
